<template>
  <component :is="getComponentName" />
</template>

<script>
import MenuDesktop from '@components/Menu/MenuDesktop/MenuDesktop.vue';
import MenuMobile from '@components/Menu/MenuMobile/MenuMobile.vue';
import useScreenWidth from '@use/useScreenWidth';

export default {
  name: 'Menu',
  components: {
    MenuMobile,
    MenuDesktop,
  },
  data() {
    return {
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    getComponentName() {
      return this.screenWidth < 992 ? 'MenuMobile' : 'MenuDesktop';
    },
  },
};
</script>
